import { LoadingSpinner } from "../../../../components/LoadingSpinner"
import AuthPageLayout from "../../../platform-layout/components/AuthPageLayout"
import AuthHeader from "../../components/AuthHeader"
import ForgotPasswordInsertCodeBox from "../components/ForgotPasswordInsertCodeBox"
import { useForgotPasswordInsertCode } from "../hooks/useForgotPasswordInsertCode"

const ForgotPasswordInsertCode = () => {
    
    const { onBackButtonClick, handleResendCode, handleInputSubmit, isLoading } = useForgotPasswordInsertCode()
    return (
        <AuthPageLayout>
            <AuthHeader
                onBackClick={onBackButtonClick}
            />
            <div className="w-full flex-1 flex flex-col items-center justify-center mt-[80px] overflow-hidden ">
                <div className="w-full sm:w-[328px] md:w-[400px] lg:w-[500px] p-[20px] bg-white">
                    <ForgotPasswordInsertCodeBox
                        onSubmit={handleInputSubmit}
                        onResendCodeClick={handleResendCode}
                    />
                </div>
            </div>
            {
                isLoading && <div className="w-full h-full div-center absolute"><LoadingSpinner /></div>
            }
        </AuthPageLayout>
    )
}

export default ForgotPasswordInsertCode
